import { KeyboardEvent, ReactElement } from 'react';
import { Sheet, SheetList } from '@methodset/calculator-ts';
import { Select } from 'antd';
import { FilterInput } from 'components/FilterInput/FilterInput';
import { Spacer } from 'components/Spacer/Spacer';
import { KeyUtils } from 'utils/KeyUtils';
import classNames from 'classnames';
import update from 'immutability-helper';
import './RangeRefEditor.less';

export type RangeData = {
    sheetId?: string,
    rangeId?: string
}
export type BlurCallback = () => void;
export type ChangeCallback = (value: RangeData, isCleared: boolean) => void;

export type RangeRefEditorProps = {
    className?: string,
    value: RangeData,
    sheets?: SheetList,
    allowClear: boolean,
    onCommit: BlurCallback,
    onChange: ChangeCallback
};

export const RangeRefEditor = (props: RangeRefEditorProps): ReactElement => {

    const handleSheetChange = (sheetId: string | undefined): void => {
        const value = update(props.value, {
            sheetId: { $set: sheetId }
        });
        props.onChange(value, false);
    }

    const handleRangeChange = (rangeId: string | undefined): void => {
        const value = update(props.value, {
            rangeId: { $set: rangeId }
        });
        props.onChange(value, false);
    }

    const handleClear = (): void => {
        const value = update(props.value, {
            sheetId: { $set: undefined }
        });
        props.onChange(value, true);
    }

    const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>): void => {
        if (KeyUtils.isCommit(e)) {
            e.stopPropagation();
            e.preventDefault();
            props.onCommit();
        }
    }

    return (
        <Spacer className={classNames("x-rangerefeditor", props.className)}>
            <Select
                className="x-rangerefeditor-sheet"
                placeholder="Select a sheet."
                value={props.value.sheetId}
                allowClear={props.allowClear}
                onBlur={() => props.onCommit()}
                onClear={() => handleClear()}
                onChange={(sheetId) => handleSheetChange(sheetId)}
            >
                {props.sheets?.map((sheet: Sheet) => (
                    <Select.Option
                        key={sheet.id}
                        value={sheet.name}
                    >
                        {sheet.name}
                    </Select.Option>
                ))}
            </Select>
            <FilterInput
                className="x-rangerefeditor-range"
                placeholder="Enter a range."
                value={props.value.rangeId}
                tester={(value: string) => /^[0-9A-Z:?]*$/.test(value)}
                onBlur={() => props.onCommit()}
                onKey={(e) => handleKeyDown(e)}
                onChange={(e) => handleRangeChange(e)}
            />
        </Spacer>
    )
}
